import React, {Component, Fragment} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import {DashboardBox} from '../components';

class Dashboard extends Component {
	render() {
		const {pageTitle} = this.props;

		return (
			<Fragment>
				<Helmet title={pageTitle}/>
				<DashboardBox/>
			</Fragment>
		);
	}
}

Dashboard.defaultProps = {
	pageTitle: 'Dashboard'
};

Dashboard.propTypes = {
	pageTitle: PropTypes.string
};

export default Dashboard;